<template>
  <div class="update-entityIds-com-page">
    <jw-modal v-model:visible="visible" :title="updateTitle" @cancel="handleCancel" :ok-loading="loading" title-align="start" @ok="handleOk" width="420px" :mask-closable="false" unmount-on-close>
      <jw-form :model="form" label-align="left" ref="editForm" @submit="handleSubmit">
        <jw-form-item class="form-label-text" :rules="[{ required: true, message: $t('请选择协作人') }]" :validate-trigger="['blur', 'input', 'change']" field="persons" :label-col-style="{ width: '100px' }" label-col-flex="auto">
          <template #label>
            <xl-label-text :value="$t('协作人')" :row="1" />
          </template>
          <fh-person position="bl" :multiple="true" :item="searchData?.userList" @cb="getVal($event, form.persons, index)"> </fh-person>
        </jw-form-item>
        <jw-form-item class="form-label-text" :rules="[{ required: true, message: $t('请选择权限') }]" field="permission" :validate-trigger="['change']" :label-col-style="{ width: '100px' }" label-col-flex="auto">
          <template #label>
            <xl-label-text :value="$t('权限')" :row="1" />
          </template>
          <jw-radio-group v-model="form.permission">
            <jw-radio v-for="item in options" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
          </jw-radio-group>
        </jw-form-item>
        <jw-form-item v-if="type === 2 || type === 3" class="form-label-text" field="entityIds" :validate-trigger="['change']" :label-col-style="{ width: '100px' }" label-col-flex="auto">
          <template #label>
            <xl-label-text :value="$t('添加其他协作人')" :row="1" />
          </template>
          <jw-space direction="vertical">
            <jw-checkbox :model-value="checkedAll" :indeterminate="indeterminate" @change="handleChangeAll">{{ $t('全选') }}</jw-checkbox>
            <jw-checkbox-group :options="objects[type]" v-model="form.entityIds" @change="handleChange"> </jw-checkbox-group>
          </jw-space>
        </jw-form-item>
      </jw-form>
      <p style="padding-left: 20px" v-if="joinGroup">
        <jw-checkbox value="true" v-model="isAddChat" @change="joinGroupChange">{{ $t('加入群组') }}</jw-checkbox>
      </p>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, toRefs, inject, computed, ref } from 'vue';
import { clientService, setService } from '@/api/';
import useLoading from '@/hooks/loading';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
export default {
  name: 'UpdateCooperation',
  setup(props, ctx) {
    const { t } = useI18n();
    const { loading, setLoading } = useLoading(false);
    const editForm = ref();
    const data = reactive({
      userIds: [], //用户id
      searchData: {}, //用户列表
      id: inject('detailParams').id, //客户id,
      type: inject('detailParams').entity,
      options: [
        { value: 1, label: t('读写') },
        { value: 2, label: t('只读') }
      ],
      indeterminate: false,
      checkedAll: false,
      form: {
        persons: [],
        permission: '',
        entityIds: []
      },
      visible: false,
      joinGroup: false, //加入群组
      updateTitle: t('新增协作人'),
      isAddChat: true,
      objects: {
        //客户和商机添加其他协作人使用
        2: [],
        3: []
      }
    });
    const handleChangeAll = (value) => {
      data.indeterminate = false;
      if (value) {
        data.checkedAll = true;
        if (data.type === 2) {
          data.form.entityIds = [3, 6, 8, 10, 12];
        } else {
          data.form.entityIds = [6, 8, 10];
        }
      } else {
        data.checkedAll = false;
        data.form.entityIds = [];
      }
    };
    const handleChange = (values) => {
      data.form.entityIds = values;
      const len = data.type === 2 ? 5 : 3;
      if (values.length == len) {
        data.checkedAll = true;
        data.indeterminate = false;
      } else if (values.length == 0) {
        data.checkedAll = false;
        data.indeterminate = false;
      } else {
        data.checkedAll = false;
        data.indeterminate = true;
      }
    };
    //加入群组
    const joinGroupChange = (value) => {
      console.log(value);
      data.isAddChat = value;
    };
    data.userIds = computed(() => data.searchData?.userList?.map((el) => el.id));
    // 新增协作人
    const addCollaborator = async () => {
      setLoading(true);
      const params = {
        businessId: data.id,
        type: data.type,
        permission: data.form.permission,
        userIds: data.userIds,
        isAddChat: data.isAddChat,
        entityIds: data.form.entityIds
      };
      console.log(params);
      try {
        const res = await clientService.addCollaborator(params);
        setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('新增失败'));
          return;
        }
        Message.success(t('操作成功'));
        data.visible = false;
        ctx.emit('cb');
      } catch (e) {
        setLoading(false);
        data.visible = false;
        Message.error(e.message || e.statusText || t('新增协作人失败'));
      }
    };
    //获取群组
    const getGroupInfo = async () => {
      setLoading(true);
      data.joinGroup = false;
      const params = {
        id: data.id,
        type: data.type
      };
      try {
        const res = await clientService.getMemberInfo(params);
        setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('新增失败'));
          data.joinGroup = false;
          return;
        }
        if (res.result?.chatId) {
          data.joinGroup = true;
        }
      } catch (e) {
        setLoading(false);
        data.joinGroup = false;
      }
    };
    // 选择部门和人员
    const tree = reactive({
      checkDepartment: false,
      isAll: true
    });
    const getVal = (v) => {
      data.searchData = v;
      const userNames = computed(() => v?.userList?.map((u) => u.userName));
      if (userNames.value) {
        editForm.value?.clearValidate(['persons']);
      }
      data.form.persons = userNames.value;
      console.log(v);
    };
    // 删除用户或部门
    const removeUserDepart = (removed) => {
      console.log(97, removed);
      const userItem = data.searchData?.userList.findIndex((item) => item.userName === removed);
      if (userItem !== -1) {
        data.searchData?.userList?.splice(userItem, 1);
      }
    };
    // 清除所有
    const clearAll = (ev) => {
      console.log(101, ev);
      if (data.searchData) {
        data.searchData.userList = [];
      }
    };
    // 详情编辑确认按钮
    const handleSubmit = ({ values, errors }) => {
      console.log('表单验证', values, errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        editForm.value?.setFields(errorArray);
        data.visible = true;
        return;
      }
      addCollaborator();
    };
    const getRuleObjList = async () => {
      try {
        const res = await setService.getRuleObjList({});
        const _c = [];
        const _o = [];
        if (!res.error) {
          res.result.map((v) => {
            if ([6, 8, 10].includes(v.value)) {
              _c.push(v);
              _o.push(v);
            }
            if ([3, 12].includes(v.value)) {
              _c.push(v);
            }
          });
        }
        data.objects[2] = _c;
        data.objects[3] = _o;
      } catch (e) {
        console.log(e);
      }
    };
    const open = () => {
      getRuleObjList();
      editForm.value?.resetFields();
      clearAll();
      getGroupInfo();
      data.searchData = {};
      data.visible = true;
      const len = data.type == 2 ? 5 : 3;
      if (data.form?.entityIds?.length == len) {
        data.checkedAll = true;
        data.indeterminate = false;
      } else if (data.form?.entityIds?.length == 0) {
        data.checkedAll = false;
        data.indeterminate = false;
      } else {
        data.checkedAll = false;
        data.indeterminate = true;
      }
    };
    const handleCancel = () => {
      editForm.value?.clearValidate();
      editForm.value?.resetFields();
      data.searchData = {};
      clearAll();
      data.visible = false;
    };
    const handleOk = () => {
      editForm.value?.handleSubmit();
    };

    return {
      open,
      handleCancel,
      handleOk,
      addCollaborator,
      getVal,
      tree,
      editForm,
      loading,
      setLoading,
      getGroupInfo,
      clearAll,
      handleSubmit,
      removeUserDepart,
      joinGroupChange,
      handleChangeAll,
      handleChange,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './update-cooperation.less';
</style>
